import React from "react";

import { Calendar, MapPin, Mail, KeyRound } from "lucide-react";

import {
  FormLayout,
  FormSection,
  FormRow,
} from "../../../../../components/layout/forms/Index";

import TextField from "../../../../../components/input/textfield/TextField";
import Select from "../../../../../components/input/select/Select";
import Button from "../../../../../components/buttons/Button";

const formStyle = {
  width: "100%",
  border: "1px solid var(--ko-border-dark-1)",
};

const wrapperStyle = {
  marginBottom: "20px",
};

export const PersonalDetailsForm = ({
  profile,
  onChange,
  onSave,
  loading = false,
}) => {
  return (
    <div className="mbr-accordion-wrapper" style={wrapperStyle}>
      <FormLayout
        title="Personal Details"
        description="Update your profile details."
        collapsible
        defaultOpen={true}
        formLayoutStyle={formStyle}
        footer={
          <Button
            type="button"
            value={loading ? "Saving..." : "Save changes"}
            onClick={onSave}
            variant="primary"
            disabled={loading}
            style={{ width: "200px" }}
          />
        }
      >
        <FormSection>
          <FormRow columns={2}>
            <TextField
              label="First name"
              name="firstName"
              value={profile?.firstName || ""}
              onChange={onChange}
              required
            />

            <TextField
              label="Last name"
              name="lastName"
              value={profile?.lastName || ""}
              onChange={onChange}
              required
            />

            <TextField
              type="month"
              label="Month / Year Born"
              name="dob"
              value={profile?.dob || ""}
              onChange={onChange}
              icon={<Calendar size={16} />}
              required
            />

            <TextField
              label="Nationality"
              name="nationality"
              value={profile?.nationality || ""}
              onChange={onChange}
            />

            <Select
              label="Gender"
              name="gender"
              value={profile?.gender || "none"}
              onChange={onChange}
              items={[
                {
                  label: "Male",
                  value: "male",
                },
                {
                  label: "Female",
                  value: "female",
                },
                {
                  label: "Non-binary",
                  value: "non_binary",
                },
                {
                  label: "Prefer not to say",
                  value: "none",
                },
              ]}
            />

            <TextField
              label="Mobile Number"
              name="mobile"
              value={profile?.mobile || ""}
              onChange={onChange}
            />
          </FormRow>
        </FormSection>

        <br />

        <FormSection title="Location">
          <FormRow>
            <TextField
              label="Suburb"
              name="suburb"
              value={profile?.suburb || ""}
              onChange={onChange}
            />

            <TextField
              label="State / Region"
              name="state"
              value={profile?.state || ""}
              onChange={onChange}
            />

            <TextField
              label="Country"
              name="country"
              value={profile?.country || ""}
              onChange={onChange}
              required
            />

            <TextField
              label="Postcode"
              name="postcode"
              value={profile?.postcode || ""}
              onChange={onChange}
              icon={<MapPin size={16} />}
            />
          </FormRow>
        </FormSection>
      </FormLayout>
    </div>
  );
};

export const SecurityForm = ({
  profile,
  password,
  setPassword,
  onSave,
  loading = false,
}) => {
  const validPassword = typeof password === "string" && password.length >= 8;

  return (
    <div className="mbr-accordion-wrapper" style={wrapperStyle}>
      <FormLayout
        title="Security"
        description="Manage your password and access."
        collapsible
        defaultOpen={false}
        formLayoutStyle={formStyle}
        footer={
          <Button
            type="button"
            value={loading ? "Saving..." : "Save password"}
            onClick={onSave}
            variant="primary"
            disabled={loading || !validPassword}
            style={{ width: "200px" }}
          />
        }
      >
        <FormSection>
          <TextField
            type="email"
            label="Email Address"
            value={profile?.email || ""}
            disabled
            icon={<Mail size={16} />}
          />

          <TextField
            type="password"
            label="New Password"
            placeholder="At least 8 characters"
            value={password || ""}
            onChange={(event) => setPassword(event.target.value)}
            showPasswordOption
            icon={<KeyRound size={16} />}
          />
        </FormSection>
      </FormLayout>
    </div>
  );
};

export const DangerZoneForm = ({ onDelete, loading = false }) => {
  return (
    <div className="mbr-accordion-wrapper" style={wrapperStyle}>
      <FormLayout
        title="Danger Zone"
        description="Permanently delete your account."
        danger
        collapsible
        defaultOpen={false}
        formLayoutStyle={formStyle}
        footer={
          <Button
            type="button"
            value={loading ? "Deleting..." : "Delete my account"}
            onClick={onDelete}
            variant="primary"
            disabled={loading}
            style={{ width: "200px" }}
          />
        }
      >
        <FormSection>
          <div className="mbr-profile__danger-box">
            <p
              className="mbr-profile__danger-text"
              style={{
                color: "var(--ko-text-light-2)",
              }}
            >
              Deleting your account will remove all of your data from Katch.
              This action cannot be undone.
            </p>
          </div>
        </FormSection>
      </FormLayout>
    </div>
  );
};
